"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Credentials = exports.InfoAuth = void 0;
var info_auth_1 = require("./info.auth");
var info_credentials_1 = require("./info.credentials");
Object.defineProperty(exports, "Credentials", { enumerable: true, get: function () { return info_credentials_1.Credentials; } });
var InfoAuth = info_auth_1.default.INSTANCE;
exports.InfoAuth = InfoAuth;
//# sourceMappingURL=index.js.map